import { defineMessages } from "@ai360/core/intl";

export const messages = defineMessages({
    build: { id: "admin.build", defaultMessage: "Build" },
    date: { id: "admin.date", defaultMessage: "Date" },
    version: { id: "admin.version", defaultMessage: "Version" },
    releaseNotes: { id: "admin.releaseNotes", defaultMessage: "Release Notes" },
    thirdPartyRef: { id: "admin.thirdPartyRef", defaultMessage: "Third-Party References" },
    cropwise: { id: "admin.cropwise", defaultMessage: "PlanetScope imagery powered by Cropwise" },
});
